import { createTheme } from '@mui/material/styles';
import { blue, grey, red, yellow } from '@mui/material/colors';

export const theme = createTheme({
    breakpoints: {
        values: {
            lg: 1280,
            md: 960,
            sm: 600,
            xl: 1920,
            xs: 0,
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                disableElevation: true,
            },
        },
        MuiUseMediaQuery: {
            defaultProps: {
                noSsr: true,
            },
        },
    },
    palette: {
        background: {
            default: '#fff',
        },
        colors: {
            blue: {
                main: blue['300'],
            },
            green: {
                contrastText: '#ffffff',
                main: '#00B579',
            },
            greenLight: {
                contrastText: '#00b588',
                main: '#d6f3ec',
            },
            grey: {
                contrastText: '#000000',
                main: grey['300'],
            },
            greyLight: {
                contrastText: '#6e8780',
                main: grey['200'],
            },
            red: {
                contrastText: '#000000',
                main: '#f44336',
            },
            redLight: {
                contrastText: '#F91F44',
                main: '#FEDBE1',
            },
            yellow: {
                main: yellow['200'],
            },
        },
        error: {
            main: red.A400,
        },
        info: {
            main: grey['600'],
        },
        inverse: {
            contrastText: '#ffffff',
            main: '#000000',
        },
        primary: {
            contrastText: '#ffffff',
            main: '#00B579',
        },
        secondary: {
            main: '#556cd6',
        },
        success: {
            main: '#00B588',
        },
        warning: {
            main: '#ffc107',
        },
    },
    typography: {
        fontSize: 13,
        h2: {
            fontSize: '2.75rem',
        },
        // body2: {
        // 	fontSize: 13,
        // },
        // body1: {
        // 	fontSize: 13,
        // },
        // caption: {
        // 	fontSize: 13,
        // },
        // button: {
        // 	fontSize: 13,
        // },
    },
});
